import { Input } from '@vrplatform/components';
import { Input as MantineInput } from '@mantine/core';
import { Controller, useFormContext } from 'react-hook-form';
import { validateEmail } from '../../../../utils';
import type { FormInputBaseType } from './_base-input-types';

type TextInputType = {
  inputType?: string;
};

type Props = TextInputType & FormInputBaseType;

export const TextInput = ({
  label,
  formKey,
  inputType = 'text',
  defaultValue = '',
  required = true,
  disabled,
  placeholder,
  onValueChange,
}: Props) => {
  const { control } = useFormContext();

  const rules =
    inputType === 'email'
      ? {
          validate: (value: string) => validateEmail(value, { required }),
        }
      : { required };

  return (
    <MantineInput.Wrapper label={label} sx={{ textAlign: 'left' }}>
      <Controller
        control={control}
        name={formKey}
        defaultValue={defaultValue}
        rules={rules}
        render={({ field: { onChange, value } }) => (
          <Input
            placeholder={placeholder || label || ''}
            value={value}
            onChange={(event) => {
              onValueChange?.(formKey, event.target.value);
              onChange(event);
            }}
            name={formKey}
            disabled={disabled}
            type={inputType}
          />
        )}
      />
    </MantineInput.Wrapper>
  );
};
